import { createContext, useContext, useState, type ReactNode } from "react";
import type {
	DiscountActionFilters,
	DiscountActionSearchContextType,
} from "./discount-actions.types";

export const DiscountActionSearchContext = createContext<DiscountActionSearchContextType>({
	setFilters: () => {},
	clearFilters: () => {},
	filters: {},
	isArchivePage: false,
});

export const useDiscountActionSearchContext = () => {
	const context = useContext(DiscountActionSearchContext);
	if (!context) {
		throw new Error(
			"useDiscountActionSearchContext must be used within a DiscountActionSearchContainer",
		);
	}
	return context;
};

export const DiscountActionSearchContextProvider = ({
	children,
	isArchivePage = false,
}: {
	children: ReactNode;
	isArchivePage: boolean;
}) => {
	const [filters, setFilters] = useState<DiscountActionFilters>({});

	const handleClearFilters = () => {
		setFilters({});
	};

	return (
		<DiscountActionSearchContext.Provider
			value={{
				filters,
				setFilters,
				clearFilters: handleClearFilters,
				isArchivePage: isArchivePage,
			}}
		>
			{children}
		</DiscountActionSearchContext.Provider>
	);
};
